import { usePermissions } from './usePermissions'

export function useMaterialCategoriesPermissions() {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions()
  
  // Specific Material Categories permission checks
  const canViewMaterialCategories = () => hasAnyPermission(['Supplier.MaterialCategories'])
  const canCreateMaterialCategories = () => hasAnyPermission(['Supplier.MaterialCategories.Create'])
  const canEditMaterialCategories = () => hasAnyPermission(['Supplier.MaterialCategories.Edit'])
  const canDeleteMaterialCategories = () => hasAnyPermission(['Supplier.MaterialCategories.Delete'])
  
  // Combined permission checks
  const canAccessMaterialCategories = () => hasAnyPermission([
    'Supplier.MaterialCategories',
    'Supplier.MaterialCategories.Create',
    'Supplier.MaterialCategories.Edit',
    'Supplier.MaterialCategories.Delete'
  ])
  
  const canManageMaterialCategories = () => hasAnyPermission([
    'Supplier.MaterialCategories.Create',
    'Supplier.MaterialCategories.Edit',
    'Supplier.MaterialCategories.Delete'
  ])
  
  const isMaterialCategoriesAdmin = () => hasAnyPermission([
    'Supplier.MaterialCategories'
  ]) || hasAllPermissions([
    'Supplier.MaterialCategories.Create',
    'Supplier.MaterialCategories.Edit',
    'Supplier.MaterialCategories.Delete'
  ])
  
  return {
    // Individual permissions
    canViewMaterialCategories,
    canCreateMaterialCategories,
    canEditMaterialCategories,
    canDeleteMaterialCategories,
    
    // Combined permissions
    canAccessMaterialCategories,
    canManageMaterialCategories,
    isMaterialCategoriesAdmin,
    
    // Direct access to base permission functions
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }
} 